import { TaskQueryBase } from "./TaskQuery";
import { BaseQuery } from "./_BaseQuery";

export class PrioritizedTaskQuery extends TaskQueryBase {
	public dateTime?:Date;
	public addIncludes?:boolean;
}
